const IconAccordionMinus = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.001 0.333008C27.7577 0.333185 35.6668 8.24323 35.667 18C35.6668 27.7568 27.7577 35.6658 18.001 35.666C8.24421 35.6658 0.33416 27.7568 0.333984 18C0.334162 8.24323 8.24421 0.333186 18.001 0.333008ZM18.001 2.33301C9.34878 2.33319 2.33416 9.3478 2.33398 18C2.33416 26.6522 9.34878 33.6658 18.001 33.666C26.6532 33.6658 33.6668 26.6522 33.667 18C33.6668 9.3478 26.6532 2.33318 18.001 2.33301Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.05 18L25 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
};

export default IconAccordionMinus;
